<template>
  <div ref="pageView" class="page-view container-view">
    <!-- title -->
    <section class="title-section fixed-view">
      <e6-title>
        自定义考核内容详情
        <template slot="breadcrumb">
          <e6-breadcrumb :breadcrumbs="breadcrumbs"></e6-breadcrumb>
        </template>
      </e6-title>
    </section>
    <!-- content -->
    <section class="content-section">
      <self-assessment-form
        pageType="detail"
        ref="editSelfAssessmentForm"
      ></self-assessment-form>
    </section>
  </div>
</template>

<script>
// components
import selfAssessmentForm from "./components/selfAssessmentForm.vue";
// api
import { getAppraisalInfo } from "@/api/businessApplication";
export default {
  components: { selfAssessmentForm },
  data() {
    return {
      loading: false,
      detailData: {},
      breadcrumbs: [
        {
          path: "/home",
          isRedirect: true,
          meta: {
            title: "首页",
          },
        },
        {
          path: "/customSelfAssessmentFrom",
          isRedirect: true,
          meta: {
            title: "自定义考核内容",
          },
        },
        {
          path: "/customSelfAssessmentFromAdd",
          isRedirect: true,
          meta: {
            title: "自定义考核内容详情",
          },
        },
      ],
    };
  },
  created() {
    this.getDetailById();
  },
  mounted() {},
  methods: {
    // 查询详情数据
    async getDetailById() {
      try {
        let res = await getAppraisalInfo({
          appraisalSelfId: this.$route.query.appraisalSelfId,
        });
        if (res.code) {
          this.$refs.editSelfAssessmentForm.init(res.result);
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.page-view {
  height: 100%;
}
.title-section {
  padding: 15px 20px 10px;
}
.content-section {
  margin: 0 20px;
  height: calc(100% - 54px);
  overflow: auto;
  background: #fff;
}
</style>
